<template>
  <div>
    <div class="tasks">
      <div
          v-for="(task, key) in work.tasks"
          :key="key"
          class="task"
      >
        {{ task }}
      </div>
    </div>
    <div class="technologies">
      <div
          v-for="(technology, key) in work.technologies"
          :key="key"
          class="technology"
      >
        <career-element-technology :technology="technology" />
      </div>
    </div>
  </div>
</template>

<script>
import CareerElementTechnology from "./CareerElementTechnology";

export default {
  name: "CareerElementWork",
  props: {
    work: Object
  },
  components: {
    CareerElementTechnology
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/mixins";

.tasks {
  margin-top: 10px;
  margin-bottom: 5px;
}

.task {
  margin: 5px 0;
  font-size: 18px;
}

.technologies {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  flex-wrap: wrap;
}

.technology {
  @include bubble;
  margin-bottom: 10px;
}
</style>